import { Type } from '@angular/core';
import { CmpsComponentPortal, CmpsComponentPortalHandle } from '@cmps/ng-uikit';

import { epicDependencies } from '../../../../store';
import { CaArea } from '../../core';
import { NewMyFocusComponent } from '../component/new-my-focus/new-my-focus.component';
import { NewMyPhaseComponent } from '../component/new-my-phrase/new-my-phase.component';
import { currentState } from '../state';
import { HandleCollection } from '../state.model';

import { destroyHandle } from './destroy-handle.function';

function createHandle(
    key: string,
    ref: HTMLElement,
    dest: HandleCollection,
    component: Type<NewMyFocusComponent | NewMyPhaseComponent>,
): CmpsComponentPortalHandle<any> {
    const compPortal =
        epicDependencies.injector.get<CmpsComponentPortal>(CmpsComponentPortal);

    if (destroyHandle(key, dest)) {
        return;
    }
    const hdl = compPortal.create(component, epicDependencies.injector, ref);
    hdl.ref.instance._key = key;
    dest[key] = hdl;
    return hdl;
}

export function createNewMyFocusHandle(key: string, ref: HTMLElement): void {
    const state = currentState();

    createHandle(key, ref, state.myFocusHdls, NewMyFocusComponent);
}

export function createNewMyFocusPhaseHandle(
    value: CaArea,
    ref: HTMLElement,
): void {
    const state = currentState();

    let key: string;
    for (const g of state.caResult.groups) {
        if (g.areas.includes(value)) {
            key = g.name;
            break;
        }
    }
    const hdl: CmpsComponentPortalHandle<NewMyPhaseComponent> = createHandle(
        key,
        ref,
        state.myFocusPhraseHdls,
        NewMyPhaseComponent,
    );
    hdl.ref.instance._parentValue = value;
}
